/** Frontend-API für den Signal-Eingang (compass-new Projektionslayer, read-only). */

const URL = '/api/signal-decisions';

export interface SignalDecision {
  signalStreamId: string;
  source: string | null;
  projectId: string | null;
  projectTitle: string | null;
  matchScore: number | null;
  traceId: string | null;
  decisionRoute: string | null;
  decisionReason: string | null;
  missingConstraints: string[] | null;
  receivedAt: string | null;
  decidedAt: string | null;
  decisionScore: number | null;
  matchedPillar: string | null;
  category: string | null;
  categoryReason: string | null;
  categoryConfidence: number | null;
}

export interface SignalDecisionsResponse {
  signals: SignalDecision[];
  routes: Record<string, number>;
  total: number;
}

async function fetchJson<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, init);
  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(body.error?.message ?? body.error ?? `Request failed: ${res.status}`);
  }
  return res.json() as Promise<T>;
}

export async function listSignalDecisions(): Promise<SignalDecisionsResponse> {
  return fetchJson<SignalDecisionsResponse>(URL);
}

export async function rebuildSignalDecisions(): Promise<SignalDecisionsResponse & { applied: number }> {
  return fetchJson<SignalDecisionsResponse & { applied: number }>(`${URL}/rebuild`, { method: 'POST' });
}

export interface SimilarityThresholds {
  relevant: number;
  unclear: number;
}

export async function getThresholds(): Promise<SimilarityThresholds> {
  return fetchJson<SimilarityThresholds>(`${URL}/thresholds`);
}
